module.exports = __webpack_public_path__ + "static/img/cpxz-bg@2x.feddaa70.png";